import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const elements = ['p', 'strong', 'em', 'del', 'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
  'table', 'thead', 'tbody', 'tr', 'th', 'td', 'h1', 'h2', 'h3', 'h4', 'hr', 'br'];
const components = {
  p: ({ children }) => <p className="leading-relaxed whitespace-pre-wrap my-2">{children}</p>,
  table: ({ children }) => <div className="overflow-x-auto my-4 rounded-xl border border-slate-700"><table className="w-full text-left text-xs">{children}</table></div>,
  th: ({ children }) => <th className="bg-slate-800 px-3 py-2 font-semibold whitespace-nowrap">{children}</th>,
  td: ({ children }) => <td className="border-t border-slate-800 px-3 py-2 align-top">{children}</td>,
  ul: ({ children }) => <ul className="list-disc pl-5 space-y-1 my-2">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 space-y-1 my-2">{children}</ol>,
  strong: ({ children }) => <strong className="text-cyan-100 font-semibold">{children}</strong>,
  code: ({ children }) => <code className="whitespace-pre-wrap break-words">{children}</code>,
};
export default function ProcurementAnswer({ content }) {
  return <div className="min-w-0 break-words">
    <Markdown remarkPlugins={[remarkGfm]} skipHtml allowedElements={elements}
      unwrapDisallowed urlTransform={() => ''} components={components}>{content}</Markdown>
  </div>;
}
